<template>
  <div class="safety-page">
    <HeroImage
      title="Safety and <br>side effects"
      subtitle='What to expect when taking <span class="text-nowrap">JORNAY PM.</span>'
      :image="imageLg"
      :image__sm="imageSm"
      alt="Adult with ADHD managing her symptoms during work hours | JORNAY PM® (methylphenidate HCl extended-release
      capsules)"
    >
    </HeroImage>

    <SafetProfile />
    <SafetyEffects />

    <PageNav :menus="navItems" customClass="mt-0"/>

    <InfoBlockSticky />
    <InfoBlock class="trigger" />
    <Footer />
  </div>
</template>

<script>
import HeroImage from "../components/elements/HeroImage.vue";
import imageLg from "@/assets/images/3_25/safety/hero@2x.webp";
import imageSm from "@/assets/images/3_25/safety/hero_s@2x.webp";

import InfoBlock from "../components/sections/InfoBlock";
import InfoBlockSticky from "../components/sections/InfoBlockSticky";
import Footer from "../components/sections/Footer";
import ogImage from "../assets/images/Jornay_OG_Image.jpg";
import PageNav from "../components/elements/PageNav.vue";
import SafetProfile from "../components/sections/SafetProfile.vue";
import SafetyEffects from "../components/sections/SafetEffects.vue";

export default {
  name: "Safety",
  metaInfo: {
    title: "JORNAY PM® (methylphenidate HCI) Safety & Side Effects",
    link: [
      {
        rel: "canonical",
        href: "https://www.jornaypm.com/safety",
      },
    ],
    meta: [
      {
        name: "description",
        content:
          "Learn what to expect when taking JORNAY PM® (methylphenidate HCI) including safety and serious side effects.  Please see full Prescribing Information, including Boxed Warning, and Medication Guide",
      },
      {
        property: "og:title",
        content: "JORNAY PM® (methylphenidate HCI) Safety & Side Effects",
      },
      {
        property: "og:description",
        content:
          "Learn what to expect when taking JORNAY PM® (methylphenidate HCI) including safety and serious side effects.  Please see full Prescribing Information, including Boxed Warning, and Medication Guide",
      },
      {
        property: "og:image",
        content: ogImage,
      },
      {
        property: 'google-site-verification',
        content: 'ARK4dFoz7A2muCj6LE7Z_Pf2IbIg41HtT0dLwNgni8I'
      }
    ],
  },
  components: {
    InfoBlock,
    InfoBlockSticky,
    Footer,
    HeroImage,
    PageNav,
    SafetProfile,
    SafetyEffects,
  },
  data() {
    return {
      imageLg,
      imageSm,
      navItems: [
        {
          title: "How to ask about JORNAY&nbsp;PM",
          routerLinkName: "Resources",
          ctaText: "Start here",
        },
        {
          title: "Find out if you can save",
          routerLinkName: "Savings",
          ctaText: "Check Here",
        },
      ],
    };
  },
};
</script>
